import { render } from "./DocPagesPage.vue?vue&type=template&id=2d8a573e&scoped=true"
import script from "./DocPagesPage.vue?vue&type=script&lang=js"
export * from "./DocPagesPage.vue?vue&type=script&lang=js"

import "./DocPagesPage.vue?vue&type=style&index=0&id=2d8a573e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8a573e"]])

export default __exports__